// Inline SVG payment card logos — official brand colors, accessibility-safe
// Static and crisp; no external CDN dependency.
export function VisaLogo({ className = "h-6" }) {
  return (
    <span className={`inline-flex items-center justify-center bg-white rounded-sm px-2 py-1 ${className}`} aria-label="Visa" data-testid="payment-logo-visa">
      <svg viewBox="0 0 750 471" className="h-full w-auto" aria-hidden="true">
        <g fillRule="evenodd">
          <path fill="#0E4595" d="M0 40C0 17.9 17.91 0 40 0h670c22.09 0 40 17.91 40 40v391c0 22.09-17.91 40-40 40H40c-22.09 0-40-17.91-40-40V40z" />
          <path fill="#FFFFFF" d="M278.198 334.228l33.36-195.76h53.358l-33.385 195.76h-53.333zm246.114-191.54c-10.572-3.966-27.137-8.222-47.822-8.222-52.726 0-89.864 26.55-90.18 64.604-.297 28.13 26.514 43.815 46.755 53.18 20.77 9.595 27.752 15.713 27.652 24.283-.13 13.124-16.587 19.116-31.923 19.116-21.355 0-32.7-2.97-50.225-10.276l-6.875-3.115-7.488 43.738c12.464 5.486 35.51 10.242 59.438 10.486 56.09 0 92.502-26.246 92.916-66.886.2-22.27-14.026-39.216-44.83-53.196-18.66-9.066-30.087-15.116-29.966-24.296 0-8.151 9.815-16.866 31.043-16.866 17.74-.276 30.586 3.61 40.594 7.575l4.86 2.305 7.342-42.34zm137.108-4.21h-41.232c-12.776 0-22.336 3.487-27.95 16.234l-79.246 179.405h56.027s9.16-24.123 11.232-29.418c6.123 0 60.555.084 68.337.084 1.596 6.853 6.452 29.334 6.452 29.334H750l-43.58-195.64zm-65.418 126.41c4.413-11.279 21.26-54.723 21.26-54.723-.316.518 4.382-11.334 7.078-18.684l3.605 16.879s10.218 46.728 12.354 56.528h-44.297zm-201.74-126.41l-52.227 133.5-5.566-27.13c-9.725-31.275-40.025-65.155-73.898-82.118l47.766 171.171 56.456-.065 84.005-195.358h-56.536z" />
          <path fill="#F2AE14" d="M155.717 138.471H69.648l-.682 4.073c66.939 16.204 111.232 55.363 129.626 102.42l-18.71-89.96c-3.226-12.395-12.597-16.094-24.165-16.533z" />
        </g>
      </svg>
    </span>
  );
}

export function MastercardLogo({ className = "h-6" }) {
  return (
    <span className={`inline-flex items-center justify-center bg-white rounded-sm px-2 py-1 ${className}`} aria-label="Mastercard" data-testid="payment-logo-mastercard">
      <svg viewBox="0 0 152 108" className="h-full w-auto" aria-hidden="true">
        <circle cx="56" cy="54" r="42" fill="#EB001B" />
        <circle cx="96" cy="54" r="42" fill="#F79E1B" />
        <path fill="#FF5F00" d="M76 24a41.99 41.99 0 010 60 41.99 41.99 0 010-60z" />
      </svg>
    </span>
  );
}

export function TroyLogo({ className = "h-6" }) {
  return (
    <span className={`inline-flex items-center justify-center bg-white rounded-sm px-2 py-1 ${className}`} aria-label="Troy" data-testid="payment-logo-troy">
      <svg viewBox="0 0 80 32" className="h-full w-auto" aria-hidden="true">
        <text x="6" y="22" fontFamily="Arial, sans-serif" fontWeight="700" fontSize="18" fill="#00ADEE">tr</text>
        <text x="28" y="22" fontFamily="Arial, sans-serif" fontWeight="700" fontSize="18" fill="#E73238">oy</text>
      </svg>
    </span>
  );
}
